import React, { CSSProperties } from 'react'
import Col from 'react-bootstrap/Col'
import moment from 'moment-timezone'
import { consoleLog } from '../managers/Logger'
import { isMobile } from 'react-device-detect'
import OverlayDiv from './OverlayDiv'
import Badge from 'react-bootstrap/Badge'

type ETAEventCellProps = {
  item: any
  style: CSSProperties
  showCost: boolean
  onClick: (event) => void
  locked: boolean
  lockSubtitle: boolean
}

class ETAEventCell extends React.Component<ETAEventCellProps> {

  static defaultProps = {
    showCost: true,
    onClick: () => null,
    locked: false,
    lockSubtitle: false
  }


  getTextLock(secondary = false) {
    var shouldBlur = this.props.locked;
    if (secondary) { 
      shouldBlur = this.props.lockSubtitle
    }
    if (shouldBlur) {
      return { color: 'transparent', textShadow: '0 0 10px rgba(0,0,0,0.5)' }
    } else {
      return { color: 'black' }
    }
  }

  render() {
    const item = this.props.item;
    consoleLog(this.props.item)
    const showCost = this.props.showCost && this.props.item && this.props.item.cost !== null && this.props.item.cost !== undefined;

    return <div style={this.props.style} onClick={() => this.props.onClick(item)}>
      <div style={{ marginBottom: '25px', cursor: 'pointer', position: 'relative' }}>
        <div>
          <div style={{position: 'relative'}}>
            <a href={this.props.locked ? null : item.link} target="_blank">
              <OverlayDiv imageUrl={item && item.image_url} boxShadow={0} style={{
                width: isMobile ? '300px' : '100%',
                height: '240px',
                borderRadius: '8px',
                filter: this.props.locked ? 'blur(8px)' : null,
                webkitFilter: this.props.locked ? 'blur(8px)' : null
              }}>
                {!this.props.locked && <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginLeft: '5px', height: '95%', width: '97%', overflowX: 'hidden' }}>
                  {item.tags && item.tags.map((item, index) => <Badge style={{ marginRight: '5px', }} variant="info">{item.label}</Badge>)}
                </div>}
              </OverlayDiv>
              {this.props.locked && <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginLeft: '5px', height: '95%', width: '97%', overflowX: 'hidden', marginTop: -20 }}>
                {item.tags && item.tags.map((item, index) => <Badge style={{ marginRight: '5px', zIndex: 5 }} variant="info">{item.label}</Badge>)}
              </div>}
              {this.props.locked && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div style={{ width: '200px', height: '100px', backgroundColor: 'black', borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div>
                    <p style={{marginBottom: 0, textAlign: 'center'}}>🔒</p>
                    <p style={{color: 'white', marginBottom: 0}}>Upgrade to unlock</p>
                  </div>

                </div>
              </div>}
            </a>
          </div>
          {showCost === true && <div
            style={{
              position: 'absolute',
              width: '40px',
              height: '40px',
              right: '10px',
              top: '5px',
              background: '#00FFF0',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '20px',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
            }}>
            {item && item.cost === 0 ? (
              <p
                style={{
                  fontSize: '14px',
                  lineHeight: '20px',
                  textAlign: 'center',
                  letterSpacing: '0.2px',
                  color: '#000000',
                  transform: 'rotate(-23.41deg)',
                  marginBottom: '0px',
                }}
              >
                Free
              </p>
            ) : (<p
              style={{
                fontSize: '14px',
                lineHeight: '20px',
                textAlign: 'center',
                letterSpacing: '0.2px',
                color: '#000000',
                transform: 'rotate(-23.41deg)',
                marginBottom: '0px',
              }}
            >
              {`$${item && item.cost}`}
            </p>
            )}
          </div>}
        </div>

        <div style={{ marginTop: '25px' }}>
          <a href={this.props.locked ? null : item.link} target="_blank">
            <p style={{ fontWeight: 'bold', fontSize: '18px', lineHeight: '24px', textAlign: 'center', letterSpacing: '0.1px', ...this.getTextLock(false) }}>
              {item && item.title}
            </p>
          </a>
          <p style={{ fontWeight: 'normal', fontSize: '14px', lineHeight: '20px', textAlign: 'center', letterSpacing: '0.2px', ...this.getTextLock(true) }}>
            {item && item.subtitle}
          </p>
        </div>
      </div>
    </div>
  }
}

export default ETAEventCell